// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";

var Js_ = {};

function toJs(t, mapJsVariablesOpt, serializeVariables) {
  var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
        return prim;
      });
  return {
          query: t.query,
          variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, t.variables)),
          id: t.id,
          optimistic: t.optimistic,
          canonizeResults: t.canonizeResults
        };
}

var ReadQueryOptions = {
  Js_: Js_,
  toJs: toJs
};

var Js_$1 = {};

var ReadFragmentOptions = {
  Js_: Js_$1
};

var Js_$2 = {};

function toJs$1(t, mapJsVariablesOpt, serialize, serializeVariables) {
  var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
        return prim;
      });
  return {
          data: Curry._1(serialize, t.data),
          broadcast: t.broadcast,
          overwrite: t.overwrite,
          query: t.query,
          variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, t.variables)),
          id: t.id
        };
}

var WriteQueryOptions = {
  Js_: Js_$2,
  toJs: toJs$1
};

var Js_$3 = {};

function toJs$2(t, serialize) {
  return {
          data: Curry._1(serialize, t.data),
          broadcast: t.broadcast,
          overwrite: t.overwrite,
          id: t.id,
          fragment: t.fragment,
          fragmentName: t.fragmentName
        };
}

var WriteFragmentOptions = {
  Js_: Js_$3,
  toJs: toJs$2
};

var Js_$4 = {};

function toJs$3(t, mapJsVariablesOpt, serializeVariables) {
  var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : (function (prim) {
        return prim;
      });
  return {
          id: t.id,
          query: t.query,
          variables: Curry._1(mapJsVariables, Curry._1(serializeVariables, t.variables)),
          optimistic: t.optimistic,
          canonizeResults: t.canonizeResults,
          broadcast: t.broadcast,
          overwrite: t.overwrite
        };
}

var UpdateQueryOptions = {
  Js_: Js_$4,
  toJs: toJs$3
};

var Js_$5 = {};

function toJs$4(t) {
  return {
          id: t.id,
          fragment: t.fragment,
          fragmentName: t.fragmentName,
          optimistic: t.optimistic,
          canonizeResults: t.canonizeResults,
          broadcast: t.broadcast,
          overwrite: t.overwrite
        };
}

var UpdateFragmentOptions = {
  Js_: Js_$5,
  toJs: toJs$4
};

var Graphql;

var Utils;

export {
  Graphql ,
  Utils ,
  ReadQueryOptions ,
  ReadFragmentOptions ,
  WriteQueryOptions ,
  WriteFragmentOptions ,
  UpdateQueryOptions ,
  UpdateFragmentOptions ,
}
/* No side effect */
